"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFlagsMarkedAsMistake = void 0;
function removeFlagsMarkedAsMistake(item) {
    if (item.mistakenly_flagged_action_items.length === 0) {
        return item;
    }
}
exports.removeFlagsMarkedAsMistake = removeFlagsMarkedAsMistake;
